export default "__VITE_ASSET__4ec48b74__"